import { SystemParameters } from '../models/system-parameters.model';

export const SYSTEM_PARAMETERS_FIELDS_TO_CONVERT = [
    SystemParameters.V_PARM_VALUE_DATE
];
